var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 502,
    viewBox: "0 0 194 502",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.219 198.471C133.584 242.542 119.766 301.38 105.522 346.951C91.7388 391.05 51.8109 402.023 13.2565 427.484C-28.4476 455.025 -57.4044 497.631 -103.39 478.058C-147.438 459.31 -95.9796 393.08 -115.72 349.468C-132.758 311.826 -212.144 285.955 -208.989 244.758C-205.011 192.808 -202.287 100.624 -160.063 70.0989C-114.736 37.3304 -66.1852 122.361 -13.3544 140.724C37.0635 158.248 94.6876 149.201 115.219 198.471Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.728 208.53C118.284 248.261 105.828 301.303 92.9878 342.385C80.5626 382.14 44.5682 392.032 9.81197 414.985C-27.7836 439.813 -53.8873 478.222 -95.3431 460.577C-135.052 443.675 -88.6638 383.969 -106.46 344.651C-121.82 310.717 -193.386 287.393 -190.543 250.254C-186.957 203.421 -184.502 120.316 -146.439 92.798C-105.577 63.2575 -61.8078 139.914 -14.1811 156.469C31.2705 172.268 83.218 164.112 101.728 208.53Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.599 214.858C107.906 251.589 96.3953 300.623 84.5294 338.601C73.0466 375.352 39.7749 384.494 7.64882 405.711C-27.1018 428.661 -51.2288 464.167 -89.5506 447.851C-126.258 432.223 -83.3817 377.031 -99.8349 340.682C-114.036 309.31 -180.191 287.744 -177.565 253.41C-174.254 210.115 -171.99 133.288 -136.807 107.852C-99.038 80.5456 -58.5734 151.414 -14.5474 166.722C27.4679 181.33 75.4862 173.795 92.599 214.858Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6115 221.799C92.6993 253.195 82.8843 295.097 72.7621 327.549C62.9666 358.953 34.5499 366.754 7.11599 384.875C-22.5592 404.476 -43.1554 434.812 -75.8948 420.855C-107.255 407.486 -70.6503 360.333 -84.717 329.263C-96.8579 302.447 -153.374 283.993 -151.143 254.651C-148.33 217.652 -146.423 151.996 -116.38 130.27C-84.1277 106.947 -49.5389 167.526 -11.9275 180.624C23.9662 193.123 64.9797 186.7 79.6115 221.799Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7586 230.959C84.6758 259.557 75.7085 297.738 66.4654 327.309C57.5207 355.925 31.6108 363.046 6.59198 379.568C-20.4708 397.441 -39.2615 425.088 -69.1022 412.387C-97.6858 400.222 -64.2931 357.244 -77.1028 328.944C-88.1588 304.517 -139.674 287.73 -137.626 260.997C-135.044 227.286 -133.276 167.466 -105.876 147.658C-76.4627 126.394 -44.9575 181.571 -10.6747 193.487C22.0423 204.858 59.4357 198.987 72.7586 230.959Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2292 239.291C71.6174 264.223 63.7913 297.513 55.7261 323.298C47.9213 348.249 25.3248 354.461 3.50402 368.871C-20.0994 384.457 -36.4906 408.566 -62.5119 397.497C-87.437 386.894 -58.3095 349.418 -69.4761 324.745C-79.1139 303.45 -124.036 288.822 -122.246 265.513C-119.99 236.121 -118.438 183.965 -94.5407 166.69C-68.8866 148.146 -41.4203 196.249 -11.525 206.632C17.0049 216.542 49.6155 211.417 61.2292 239.291Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7586 245.881C65.2294 268.613 58.0881 298.97 50.7296 322.481C43.6087 345.234 23.0003 350.901 3.09834 364.043C-18.4295 378.258 -33.381 400.243 -57.1107 390.153C-79.8406 380.488 -53.2722 346.312 -63.453 323.816C-72.24 304.4 -113.206 291.067 -111.571 269.813C-109.51 243.012 -108.089 195.454 -86.2922 179.7C-62.8938 162.788 -37.8508 206.646 -10.5881 216.111C15.4295 225.143 45.1705 220.466 55.7586 245.881Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8773 263.204C42.5436 279.204 37.5219 300.566 32.3466 317.112C27.3385 333.124 12.8384 337.11 -1.16382 346.356C-16.31 356.358 -26.828 371.829 -43.5259 364.725C-59.5204 357.921 -40.8296 333.873 -47.9953 318.04C-54.1801 304.375 -83.0066 294.987 -81.8584 280.03C-80.4105 261.169 -79.4153 227.7 -64.0804 216.615C-47.6184 204.715 -26.8906 222.161 -7.70682 228.825C10.6008 235.184 28.4247 245.318 35.8773 263.204Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3717 270.314C31.7355 283.174 27.7331 300.328 23.602 313.614C19.6044 326.47 9.81898 333.221 -3.23589 337.067C-7.64482 337.293 -8.21399 337.609 -14.6295 334.868C-27.4628 329.384 -35.0572 326.994 -40.8214 314.267C-45.7964 303.283 -68.9224 295.709 -68.0188 283.695C-66.8792 268.546 -66.1194 241.662 -53.8354 232.775C-40.6484 223.234 -24.0074 237.272 -8.6167 242.647C6.07106 247.776 20.3752 255.937 26.3717 270.314Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3561 273.922C18.3358 283.433 15.4523 296.084 12.4619 305.879C9.56807 315.357 2.40502 320.309 -7.16792 323.107C-10.4044 323.259 -10.8213 323.491 -15.5405 321.446C-24.9809 317.357 -30.5646 315.568 -34.8378 306.154C-38.526 298.029 -55.5303 292.363 -54.9055 283.497C-54.1175 272.317 -53.6462 252.473 -44.6554 245.951C-35.0038 238.951 -22.7402 249.368 -11.4226 253.385C-0.621816 257.219 9.90701 263.29 14.3561 273.922Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82631 276.841C5.20033 282.505 3.50637 290.028 1.74518 295.852C0.0408486 301.488 -4.20263 304.425 -9.87886 306.076C-11.799 306.163 -12.046 306.3 -14.8489 305.077C-20.4556 302.631 -25.9895 302.463 -28.3819 300.207C-30.7742 297.951 -33.2581 299.81 -38.2563 282.445C-37.8038 275.794 -37.5507 263.987 -32.2248 260.119C-26.5076 255.966 -19.2172 262.181 -12.4966 264.586C-6.08302 266.882 0.172247 270.508 2.82631 276.841Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.43517 279.009C-0.710385 283.122 -1.93444 288.582 -3.20823 292.808C-4.4409 296.898 -6.18987 301.256 -11.6316 300.223C-13.0239 300.284 -13.203 300.384 -15.2362 299.495C-19.3034 297.716 -23.3164 297.591 -25.0525 295.952C-26.7887 294.313 -31.6723 292.173 -32.2233 283.053C-31.8989 278.226 -31.7222 269.655 -27.8624 266.851C-23.7188 263.84 -18.4286 268.355 -13.5537 270.105C-8.90155 271.775 -4.36343 274.411 -2.43517 279.009Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMonth);
export default __webpack_public_path__ + "static/media/LeftMonth.b029a7b451ff0390dc044df91ec63f61.svg";
export { ForwardRef as ReactComponent };